import {
  APIInterfaceI, buildRequest, buildFileUploadRequest, PaginationT,
} from '.';

class SCHCTemplates implements APIInterfaceI {
  getAll = (pagination: PaginationT) => (
    buildRequest('GET', `/templates?cursor=${pagination.cursor}&limit=${pagination.limit}`)
  )

  getOne = (targetId: string) => (
    buildRequest('GET', `/templates/${targetId}`)
  )

  delete = (targetId: string) => (
    buildRequest('DELETE', `/templates/${targetId}`)
  )

  getStacks = () => (
    buildRequest('GET', '/templates/stacks')
  )

  getDefaultRules = (stack: string) => (
    buildRequest('GET', `/templates/default-rule?stack=${stack}`)
  )

  getVariables = (targetId: string) => (
    buildRequest('GET', `/templates/${targetId}/variables`)
  )

  downloadJSON = (targetId: string) => (
    buildRequest('GET', `/templates/${targetId}/download`)
  )

  downloadCBORPackage = (targetId: string) => (
    buildRequest('GET', `/templates/${targetId}/cbor/download`)
  )

  register = (formData: any) => (
    buildRequest('POST', '/templates', formData)
  )

  registerFromJSONFile = (json: File) => (
    buildFileUploadRequest('POST', '/templates/json-upload', json)
  )

  update = (targetId: string, formData: any) => (
    buildRequest('PUT', `/templates/${targetId}`, formData)
  )
}

export default SCHCTemplates;
